export const METER_BLOCK_SIZE = '7.25rem';
export const TEXT_BLOCK_SIZE = '3.125rem';